import React from "react";

import "./index.scss";

const AlarmsIcon = props => (
  <svg
    id="Alert_Alarms_SVG"
    data-name="Dashboard"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    className="alert-alarms"
  >
    <g id="Alert_Alarms" data-name="Alert/Alarms" transform="translate(16 16)">
      <g id="Group_8730" data-name="Group 8730" transform="translate(-16 -16)" className={`default ${props.active ? "active" : ""}`}>
        <path id="Path_8559" data-name="Path 8559" className="cls-1" d="M0,0H32V32H0Z" />
        <path id="Path_8560" data-name="Path 8560" className="cls-2" d="M4,26.364,16,5.637,28,26.364Z" />
        <g id="Group_8729" data-name="Group 8729">
          <rect id="Rectangle_247" data-name="Rectangle 247" className="cls-3" width="1.184" height="1.184" transform="translate(15.408 21.961)" />
          <rect id="Rectangle_248" data-name="Rectangle 248" className="cls-3" width="1.184" height="7" transform="translate(15.408 13)" />
        </g>
      </g>
    </g>
  </svg>
);

export default AlarmsIcon;
